import { render, staticRenderFns } from "./return-dialog.vue?vue&type=template&id=721e1395&"
import script from "./return-dialog.vue?vue&type=script&lang=js&"
export * from "./return-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports